import { Stack, Tooltip, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CustomDataGrid from "components/customDataGrid";
import { currencyFormat, findKeyByValue } from "config/functions";
import { YESH_INVOICE_DOCUMENT_TYPE } from "containers/dashboard/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const RevenueForecast = ({ data, setData, dialogTitle }) => {
    const { bt } = useBizTypeTranslation();
    const onClose = () => { setData(null) };

    return (
        <CustomDialog width={600} open={data ? true : false} onClose={onClose} title={dialogTitle}>
            <Stack>
                <CustomDataGrid
                    maxHeight={450}
                    minHeight={450}
                    borderRadius="10px 10px 10px 10px"
                    columns={[
                        {
                            field: "month",
                            headerName: bt("MONTH"),
                            filterable: true,
                            width: 120,
                        },
                        {
                            field: "retainer",
                            headerName: bt("RETAINER"),
                            filterable: true,
                            width: 120,
                            renderCell: (params) => {
                                const str = params?.row?.retainerLists
                                    ?.map(item => {
                                        return (
                                            <Stack>
                                                <Typography fontSize={14} color="bgPage.main">
                                                    {`${item.customerName} - ${currencyFormat(item.price)}`}
                                                </Typography>
                                            </Stack>
                                        )
                                    })

                                return (
                                    <Tooltip title={str}>
                                        {currencyFormat(params?.row?.retainer)}
                                    </Tooltip>
                                )
                            }
                        },
                        {
                            field: "oneTime",
                            headerName: bt("ONE_TIME"),
                            filterable: true,
                            width: 120,
                            renderCell: (params) => {
                                const str = params?.row?.oneTimeLists
                                    ?.map(item => {
                                        return (
                                            <Stack>
                                                <Typography fontSize={14} color="bgPage.main">
                                                    {`${item.CustomerName} - ${currencyFormat(item.TotalPrice)}`}
                                                </Typography>
                                            </Stack>
                                        )
                                    })

                                return (
                                    <Tooltip title={str}>
                                        {currencyFormat(params?.row?.oneTime)}
                                    </Tooltip>
                                )
                            }

                        },
                        {
                            field: "total",
                            headerName: bt("TOTAL"),
                            filterable: true,
                            width: 200,
                            valueFormatter: (params) => currencyFormat(params)

                        },
                    ]}
                    list={data?.map((item) => ({
                        ...item,
                        retainer: item?.revenue?.retainer,
                        oneTime: item?.revenue?.oneTime,
                        total: item?.revenue?.total,
                        retainerLists: item?.lists?.retainers,
                        oneTimeLists: item?.lists?.oneTime,
                    })) ?? []
                    }
                />

            </Stack>
        </CustomDialog>
    );
};
export default RevenueForecast;